import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { PatientApi } from '../apis/patient/patient.api';
import { UserStore } from '../stores/user.store';
import { UserTypeEnum } from '@oranta-mis/sdk';

@Injectable({
  providedIn: 'root',
})
export class AuthPatientService {
  constructor(
    private readonly patientApi: PatientApi,
    private readonly userStore: UserStore,
  ) {}

  isAuthenticated(): boolean {
    if (!localStorage.getItem('token')) {
      return false;
    }
    return true;
  }

  canActivate(): Observable<boolean> {
    return this.patientApi.getUser().pipe(
      map((user) => {
        this.userStore.set({
          ...user,
          type: UserTypeEnum.patient,
        });

        return !!user;
      }),
    );
  }
}
